<template>
  <nav class=" cor-primaria-bg">
    <div class="container nav-wrapper  ">
      <router-link :to="link" replace class="left">
        <i style="margin-left: 8px" class="material-icons md-30">arrow_back</i>
      </router-link>
      <span style="padding-left: 15px; font-weight: bold">{{titulo}}</span>
    </div>
  </nav>
</template>

<script>
export default {
  name: "MenuSuperior",
  data(){
    return{
      drawer:false
    }
  },
  props: ["link", "titulo"]
};
</script>



// WEBPACK FOOTER //
// src/components/Widgets/MenuSuperior.vue